<template>
    <div>

        <div class="greybox">
            <input
                class=""
                type="search"
                placeholder="Find claim by reference"
                aria-label="Search"
                v-model="quickSearch">
            <button
                class="button"
                type="submit"
                @click="handleFindClick">
                Find
            </button>&nbsp;
            <button
                class="button"
                type="cancel"
                @click="handleResetClick">
                Reset
            </button>
        </div>
        <hr />
        <div  v-if="!isLoading" class="greybox">
          <div v-if="totalRecords != 0 && !viewAllClaims && claimsList.length > 0">
              <h2 class="mb-2">Your most recent claim...</h2>
              <claim-list-item :item="claimsList[0]" />
              <button class="button mt-2" @click="handleViewAllClick()">
                View all claims
              </button>
          </div>
          <div v-else>
            <claim-list-item v-for="(claim, index) in claimsList" :item="claim" :key="index"/>
          </div>
        </div>
        <div v-else>
            <span>Loading...</span>
        </div>
        <br />
        <b-pagination
            v-if="totalRecords > pageSize"
            align="right"
            size="md"
            :total-rows="totalRecords"
            v-model="currentPage"
            :per-page="pageSize"
            @input="handlePagenationInput">
        </b-pagination>

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>

    </div>
</template>

<script>

import taskList from '@/components/TaskList.vue'
import claimListItem from '@/components/ClaimListItem.vue'

import { mapActions } from 'vuex'

import loading from 'vue-loading-overlay'

export default {
  name: 'claimsList',
  components: {
    claimListItem,
    taskList,
    loading
  },
  data: () => {
    return {
      currentPage: 1,
      quickSearch: null,
      includeAll: true,
      viewAllClaims: false
    }
  },
  mounted () {
    this.load()
  },
  computed: {
    isLoading () {
      return this.$store.state.myclaims.loading
    },
    claimsList () {
      return this.$store.state.myclaims.claimsList
    },
    pageSize () {
      if (this.$store.state.myclaims.pagenation) {
        return this.$store.state.myclaims.pagenation.pageSize
      } else {
        return 5
      }
    },
    totalRecords () {
      if (this.$store.state.myclaims.pagenation) {
        return this.$store.state.myclaims.pagenation.totalRecords
      } else {
        return 0
      }
    }
  },
  methods: {
    ...mapActions({
      load: 'myclaims/getClaimsList'
    }),
    handleFindClick () {
      this.load(
        {
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch
        })
    },
    handleResetClick () {
      this.quickSearch = ''
      this.load(
        {
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch
        })
    },
    handlePagenationInput (payload) {
      this.load({ pageNumber: payload, pageSize: this.pageSize })
    },
    handleViewAllClick () {
      this.viewAllClaims = true
    },
  }
}
</script>
